import React, { createContext, useCallback, useContext, useState } from "react";

/**
 * Right contextual panel state.
 *  panel = { type: 'task'|'meeting'|'issue'|'approval', id, data }
 */
const PanelCtx = createContext(null);

export function PanelProvider({ children }) {
  const [panel, setPanel] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const open = useCallback((type, item) => {
    setPanel({ type, id: item.id, data: item });
  }, []);
  const close = useCallback(() => setPanel(null), []);
  const triggerRefresh = useCallback(() => setRefreshKey((k) => k + 1), []);

  return (
    <PanelCtx.Provider value={{ panel, open, close, refreshKey, triggerRefresh }}>
      {children}
    </PanelCtx.Provider>
  );
}

export const usePanel = () => useContext(PanelCtx);
